module.exports = __webpack_public_path__ + "media/images/ohap_assignment_open-bbb11db93e8b141e47c7fef3747545c8.png";